__turbopack_context__.v({
  "industryLinkList": "Tabs-module__sPePnq__industryLinkList",
  "panel": "Tabs-module__sPePnq__panel",
  "stacked": "Tabs-module__sPePnq__stacked",
  "tab": "Tabs-module__sPePnq__tab",
  "tabActive": "Tabs-module__sPePnq__tabActive",
  "tablist": "Tabs-module__sPePnq__tablist",
  "wrapper": "Tabs-module__sPePnq__wrapper",
});
